import styled from 'styled-components';

interface ColumnProps {
  clamp?: number;
  isDragOver?: boolean;
}

interface OrderProps {
  visible?: boolean;
}

export const Container = styled.td<ColumnProps>`
  padding: 15px 15px 15px 20px;
  font-size: 14px;
  border-left: ${(props) =>
    props.isDragOver ? `1px solid ${props.theme.colors.primary}` : ''};
  background-color: ${(props) => props.theme.colors.table.header};
  font-weight: 500;
  color: ${(props) => props.theme.colors.text};
  cursor: pointer;
  position: relative;

  &:hover div {
    visibility: visible !important;
  }

  &:hover div svg {
    visibility: visible !important;
  }
`;

export const Row = styled.div`
  display: flex;
  align-items: center;
  gap: 3px;
`;

export const Drag = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  left: 5px;
  cursor: grab;

  svg {
    visibility: hidden;
  }
`;

export const Order = styled.div<OrderProps>`
  display: flex;
  flex-direction: column;
  margin-top: 2px;
  transition: all 0.3s ease-in;
  visibility: ${(props) => (props.visible ? 'visible' : 'hidden')};

  svg:last-child {
    margin-top: -2px;
  }
`;
